import { tokens } from "@opendoor/tokens-studio/dist/bricks-next/tokens/Components";
import { styled, useMedia, useProps } from "@tamagui/core";
import { Dialog as TamaguiDialog } from "@tamagui/dialog";
import { ScrollView } from "react-native-web";
import { Box } from "../Box";
import { VisuallyHidden } from "../shared/VisuallyHidden";
import { jsx, jsxs } from "react/jsx-runtime";
const { dialog: dialogTokens } = tokens, StyledTitle = styled(TamaguiDialog.Title, {
  name: "DialogTitle",
  fontFamily: "$body",
  color: dialogTokens.color.content.default,
  variants: {
    typography: {
      "...fontSize": (fontSize) => ({
        fontSize,
        fontWeight: fontSize,
        letterSpacing: fontSize,
        lineHeight: fontSize
      })
    }
  }
}), StyledDescription = styled(TamaguiDialog.Description, {
  name: "DialogDescription",
  fontFamily: "$body",
  color: dialogTokens.color.content.default,
  variants: {
    typography: {
      "...fontSize": (fontSize) => ({
        fontSize,
        fontWeight: fontSize,
        letterSpacing: fontSize,
        lineHeight: fontSize
      })
    }
  }
}), Title = (propsIn) => {
  const props = useProps(propsIn);
  return /* @__PURE__ */ jsx(StyledTitle, { ...props });
}, Description = (propsIn) => {
  const props = useProps(propsIn);
  return /* @__PURE__ */ jsx(StyledDescription, { ...props });
}, ScrollViewWrapper = ({ children }) => {
  const { smallerThanMD } = useMedia();
  return smallerThanMD ? /* @__PURE__ */ jsx(TamaguiDialog.Sheet.ScrollView, { flex: 0, children }) : /* @__PURE__ */ jsx(ScrollView, { children });
}, Content = ({
  title,
  titleProps,
  hideTitle,
  description,
  descriptionProps,
  hideDescription,
  children
}) => /* @__PURE__ */ jsxs(
  Box,
  {
    flexGrow: 1,
    flexShrink: 1,
    paddingTop: dialogTokens.margin.mobile.top,
    paddingBottom: dialogTokens.margin.mobile.bottom,
    $largerThanSM: {
      paddingTop: dialogTokens.margin.desktop.top,
      paddingBottom: dialogTokens.margin.desktop.bottom
    },
    children: [
      /* @__PURE__ */ jsx(VisuallyHidden, { visible: !hideTitle, children: /* @__PURE__ */ jsx(
        Box,
        {
          paddingHorizontal: dialogTokens.margin.mobile.leftRight,
          paddingBottom: dialogTokens.padding.titleAndDescription.mobile,
          $largerThanSM: {
            paddingHorizontal: dialogTokens.margin.desktop.leftRight,
            paddingBottom: dialogTokens.padding.titleAndDescription.desktop
          },
          children: /* @__PURE__ */ jsx(
            Title,
            {
              typography: dialogTokens.typography.title.small,
              ...titleProps,
              $largerThanSM: {
                typography: dialogTokens.typography.title.medium,
                marginRight: dialogTokens.margin.desktop.titleRight,
                ...titleProps?.$largerThanSM
              },
              children: title
            }
          )
        }
      ) }),
      /* @__PURE__ */ jsx(ScrollViewWrapper, { children: /* @__PURE__ */ jsxs(
        Box,
        {
          paddingHorizontal: dialogTokens.margin.mobile.leftRight,
          $largerThanSM: {
            paddingHorizontal: dialogTokens.margin.desktop.leftRight
          },
          children: [
            /* @__PURE__ */ jsx(VisuallyHidden, { visible: !hideDescription, children: /* @__PURE__ */ jsx(
              Description,
              {
                typography: dialogTokens.typography.description.small,
                ...descriptionProps,
                $largerThanSM: {
                  typography: dialogTokens.typography.description.medium,
                  ...descriptionProps?.$largerThanSM
                },
                children: description
              }
            ) }),
            /* @__PURE__ */ jsx(Box, { children })
          ]
        }
      ) })
    ]
  }
);
export {
  Content
};
